(function ($) {
    'use strict';

    var STORAGE_KEY = 'feature-announcements-seen';

    function getSeenFeatures() {
        try {
            return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
        } catch (e) {
            return [];
        }
    }

    function saveSeenFeature(featureId) {
        var seen = getSeenFeatures();
        if (seen.indexOf(featureId) === -1) {
            seen.push(featureId);
            localStorage.setItem(STORAGE_KEY, JSON.stringify(seen));
        }
    }

    function isFeatureSeen(featureId) {
        return getSeenFeatures().indexOf(featureId) !== -1;
    }

    function isSidebarCollapsed() {
        return $('body').hasClass('sidebar-collapse');
    }

    window.FeatureAnnouncements = {
        init: function (announcements) {
            // Create a single tooltip element with richer structure
            var $tooltip = $('<div class="feature-tooltip">' +
                '<div class="feature-tooltip-title"><i class="fas fa-sparkles"></i> <span></span></div>' +
                '<div class="feature-tooltip-body"></div>' +
                '</div>').appendTo('body');

            announcements.forEach(function (announcement) {
                // Skip if already seen
                if (isFeatureSeen(announcement.FeatureId)) {
                    return;
                }

                var $target = $(announcement.TargetSelector);
                if (!$target.length) {
                    return;
                }

                $target.addClass('feature-badge-container');
                $target.attr('data-feature-id', announcement.FeatureId);
                
                var $badge = $('<span class="feature-new-badge">' + 
                    '<i class="fas fa-star"></i> Novo!</span>');
                
                $badge.addClass('badge-position-' + (announcement.BadgePosition || 'top-right'));
                $target.append($badge);

                // Store tooltip data on the target
                $target.data('feature-tooltip-title', announcement.Title);
                $target.data('feature-tooltip-text', announcement.Description);

                // Find the parent nav-item and its link for collapsed state
                var $navItem = $target.closest('.nav-item');
                var $navLink = $navItem.find('> a.nav-link');

                function showTooltip() {
                    var title = $target.data('feature-tooltip-title') || 'Nova Funcionalidade';
                    var text = $target.data('feature-tooltip-text');
                    
                    // When collapsed, position relative to the nav-link (the icon area)
                    var $positionElement = isSidebarCollapsed() && $navLink.length ? $navLink : $badge;
                    
                    if (!$positionElement.length || !$positionElement.is(':visible')) {
                        $positionElement = $navItem.length ? $navItem : $target;
                    }

                    var rect = $positionElement[0].getBoundingClientRect();
                    var tooltipHeight = $tooltip.outerHeight();
                    
                    // Calculate centered vertical position
                    var topPos = rect.top + (rect.height / 2);
                    var leftPos = rect.right + 12;

                    // Set content
                    $tooltip.find('.feature-tooltip-title span').text(title);
                    $tooltip.find('.feature-tooltip-body').text(text);
                    
                    // Position and show
                    $tooltip.css({
                        top: topPos,
                        left: leftPos,
                        transform: 'translateY(-50%)'
                    }).addClass('visible');
                }

                function hideTooltip() {
                    $tooltip.removeClass('visible');
                }

                // Bind hover to badge (for expanded sidebar)
                $badge.on('mouseenter', showTooltip);
                $badge.on('mouseleave', hideTooltip);

                // Bind hover to nav-link (for collapsed sidebar)
                if ($navLink.length) {
                    $navLink.on('mouseenter', function () {
                        if (isSidebarCollapsed()) {
                            showTooltip();
                        }
                    });
                    $navLink.on('mouseleave', function () {
                        if (isSidebarCollapsed()) {
                            hideTooltip();
                        }
                    });
                }
                
                // Mark as seen on click
                $target.on('click', function () {
                    FeatureAnnouncements.markAsSeen(announcement.FeatureId);
                });
            });
        },

        markAsSeen: function (featureId) {
            saveSeenFeature(featureId);
            $('[data-feature-id="' + featureId + '"]')
                .find('.feature-new-badge')
                .fadeOut(300, function () { $(this).remove(); });
        },

        dismissAll: function () {
            $('.feature-new-badge').each(function () {
                var featureId = $(this).closest('[data-feature-id]').attr('data-feature-id');
                if (featureId) {
                    saveSeenFeature(featureId);
                }
            }).fadeOut(300, function () { $(this).remove(); });
        },

        clearSeen: function () {
            localStorage.removeItem(STORAGE_KEY);
            console.log('Feature announcements cleared. Refresh to see badges again.');
        }
    };
})(jQuery);